import * as React from 'react';
import { SVGProps } from 'react';
import styled from 'styled-components';

const SVG = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11.5 8.75h-.75.75Zm.909 2.678-.582.473.582-.473ZM5.25 8.75V6.5h-1.5v2.25h1.5Zm5.5-2.25v2.25h1.5V6.5h-1.5Zm0 2.25c0 1.49.572 2.53 1.077 3.151l1.164-.946c-.335-.411-.741-1.126-.741-2.205h-1.5Zm1.424 2.5H4v1.5h8.174v-1.5Zm-.347.651c-.147-.18-.099-.348-.082-.391a.452.452 0 0 1 .43-.26v1.5c.547 0 .854-.409.965-.688.111-.281.153-.735-.15-1.107l-1.163.946ZM8 2.25A4.25 4.25 0 0 0 3.75 6.5h1.5A2.75 2.75 0 0 1 8 3.75v-1.5Zm2.486 3.072c.169.356.264.755.264 1.178h1.5c0-.65-.147-1.269-.41-1.822l-1.354.644ZM8 3.75c.509 0 .983.137 1.39.377l.76-1.294A4.234 4.234 0 0 0 8 2.25v1.5Z"
      fill="currentColor"
    />
    <path
      d="M3 13 13 3M9 14H7M8 1v1.5"
      stroke="currentColor"
      strokeWidth={1.5}
    />
  </svg>
);

const StyledSvgBellCrossed = styled(SVG)`
  font-size: ${props => (props.fontSize ? props.fontSize : '1.6rem')};
  color: ${({ color, theme }) =>
    color ? color : theme.colors.neutralColors.charcoal};
  vertical-align: middle;
  shape-rendering: inherit;
  transform: translate3d(0, 0, 0);
`;
export default StyledSvgBellCrossed;
